import { IsNotEmpty, IsString } from 'class-validator';

export class SignInResult {
  @IsString()
  @IsNotEmpty()
  accessToken: string;

  @IsString()
  @IsNotEmpty()
  refreshToken: string;
}
